// ABLE Task Helper Functions

export const getStatusLabel = (status) => {
  const labels = { 
    all: 'All', 
    active: 'Active', 
    done: 'Done',
    unblocked: 'Unblocked',
    blocked: 'Blocked'
  };
  return labels[status] || status;
};

export const calculateAutoStatus = (deadline) => {
  if (!deadline) return 'Unprioritized';
  
  const now = new Date();
  const dueDate = new Date(deadline);
  const daysUntil = Math.ceil((dueDate - now) / (1000 * 60 * 60 * 24));
  
  if (daysUntil <= 7) return 'Now';
  if (daysUntil <= 21) return 'Next';
  if (daysUntil <= 365) return 'Later';
  return 'Someday';
};

export const isValidDate = (dateString) => {
  if (!dateString) return true;
  const date = new Date(dateString);
  return date instanceof Date && !isNaN(date);
};

export const matchesPriorityFilter = (task, capacityPriority) => {
  if (capacityPriority.includes('Scheduled')) {
    return !!task.deadline;
  }
  if (capacityPriority.length === 0) return true;
  return capacityPriority.includes(task.priority);
};

export const matchesContextFilters = (task, capacity) => {
  if (capacity.area.length > 0 && task.area && !capacity.area.includes(task.area)) return false;
  if (capacity.project.length > 0 && task.project && !capacity.project.includes(task.project)) return false;
  if (capacity.release.length > 0 && task.release && !capacity.release.includes(task.release)) return false;
  if (capacity.workflow.length > 0 && task.workflow && !capacity.workflow.includes(task.workflow)) return false;
  if (capacity.timeOfDay.length > 0 && task.timeOfDay && !capacity.timeOfDay.includes(task.timeOfDay)) return false;
  if (capacity.physical.length > 0 && task.physical && !capacity.physical.includes(task.physical)) return false;
  if (capacity.mental.length > 0 && task.mental && !capacity.mental.includes(task.mental)) return false;
  if (capacity.social.length > 0 && task.social && !capacity.social.includes(task.social)) return false;
  return true;
};

export const isTaskBlocked = (task, allTasks) => {
  if (!task || !task.blockedBy || task.blockedBy.length === 0) return false;
  if (!allTasks || !Array.isArray(allTasks)) return false;
  return task.blockedBy.some(blockerId => {
    const blocker = allTasks.find(t => t.id === blockerId);
    return blocker && !blocker.done;
  });
};

export const getBlockingTasks = (task, allTasks) => {
  if (!task || !task.blockedBy || task.blockedBy.length === 0) return [];
  if (!allTasks || !Array.isArray(allTasks)) return [];
  return task.blockedBy
    .map(id => allTasks.find(t => t.id === id))
    .filter(t => t !== undefined);
};

export const getBlockedTasks = (task, allTasks) => {
  if (!task || !task.blocks || task.blocks.length === 0) return [];
  if (!allTasks || !Array.isArray(allTasks)) return [];
  return task.blocks
    .map(id => allTasks.find(t => t.id === id))
    .filter(t => t !== undefined);
};
